module.exports = __webpack_public_path__ + "img/analog-phone.d26d5b00.svg";